interface BannerProps {
  setBannerIsVisible: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function Banner(props: BannerProps) {
  return (
    <div className="w-full bg-secondary text-white min-h-16 flex items-center justify-between p-4">
      <p className="text-lg font-medium">
        Tossée est actuellement au stade de version <b>Béta</b> donnez nous
        votre avis via notre serveur{' '}
        <a
          className="underline"
          target="_blank"
          rel="noreferrer"
          href="https://discord.gg/CMf829s5Sd"
        >
          Discord
        </a>
        .
      </p>
      <div
        onClick={() => props.setBannerIsVisible(false)}
        className="cursor-pointer"
      >
        <svg
          className="w-6"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.46967 5.46967C5.76256 5.17678 6.23744 5.17678 6.53033 5.46967L18.5303 17.4697C18.8232 17.7626 18.8232 
                        18.2374 18.5303 18.5303C18.2374 18.8232 17.7626 18.8232 17.4697 18.5303L5.46967 6.53033C5.17678 6.23744 5.17678 5.76256 5.46967 5.46967Z"
            fill="#FFFFFF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.5303 5.46967C18.8232 5.76256 18.8232 6.23744 18.5303 6.53033L6.53035 18.5303C6.23745 18.8232 5.76258 
                        18.8232 5.46969 18.5303C5.17679 18.2374 5.17679 17.7626 5.46968 17.4697L17.4697 5.46967C17.7626 5.17678 18.2374 5.17678 18.5303 5.46967Z"
            fill="#FFFFFF"
          />
        </svg>
      </div>
    </div>
  );
}
